import React from 'react';
import { Icon, useAuthContext } from '@archre2/react-core';

const PageFooter = ({ config, footer }) => {
  const { session } = useAuthContext();
  return (
    <>
      {footer && (
        <div className="footer text-grey text-caption margin-y-sm margin-x-md">
          <div className="footer-deck" id="footer"></div>
          <div className="app-info">
            <div>
              <span id="policy-user-manual"></span>
              {session.connectionType === 'Arch' && (
                <a
                  href="https://archre.atlassian.net/wiki/x/AQCyzg"
                  rel="noreferrer"
                  target="_blank"
                  className="margin-x-md"
                >
                  <Icon className={`margin-x-sm`}>book</Icon>
                  <span>How to Guides</span>
                </a>
              )}
            </div>
            <div>{`v${config.VERSION}-${config.ENVIRONMENT}`}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(PageFooter);
